var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: this.saving,
          expression: "this.saving"
        }
      ],
      ref: "judgmentForm",
      attrs: { model: _vm.printerJudgment, "label-width": "190px" }
    },
    [
      !this.isReappraisal
        ? _c(
            "el-form-item",
            {
              staticClass: "compact-form-item",
              style: { lineHeight: "10px !important" },
              attrs: { label: _vm.gradeLabel() }
            },
            [_vm._v(_vm._s(_vm.application.grade))]
          )
        : _vm._e(),
      _vm.application.grade_description
        ? _c(
            "el-form-item",
            {
              staticClass: "compact-form-item",
              attrs: { label: _vm.gradeDescriptionLabel() }
            },
            [_vm._v(_vm._s(_vm.application.grade_description))]
          )
        : _vm._e(),
      _c("el-form-item", { attrs: { label: "Απόφαση Προέδρου" } }, [
        _c(
          "span",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loadingPresidentDecision,
                expression: "loadingPresidentDecision"
              }
            ]
          },
          [_vm._v(_vm._s(_vm.presidentDecisionText))]
        )
      ]),
      _vm.departmentName
        ? _c("el-form-item", { attrs: { label: "Με" } }, [
            _c("span", [_vm._v(_vm._s(_vm.departmentName))])
          ])
        : _vm._e(),
      _c(
        "el-form-item",
        { attrs: { label: "Εσωτερικό Σχόλιο" } },
        [
          _c("el-input", {
            staticClass: "biggest",
            attrs: {
              type: "textarea",
              autosize: { minRows: 4, maxRows: 10 },
              placeholder: "Εισάγετε κείμενο για τον Πρόεδρο"
            },
            model: {
              value: _vm.printerJudgment.comment,
              callback: function($$v) {
                _vm.$set(_vm.printerJudgment, "comment", $$v)
              },
              expression: "printerJudgment.comment"
            }
          })
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "Στην Αναμονή" } },
        [
          _c("el-checkbox", {
            attrs: { label: "Ναι", border: "" },
            on: { change: _vm.toggleQueue },
            model: {
              value: _vm.printerJudgment.queue,
              callback: function($$v) {
                _vm.$set(_vm.printerJudgment, "queue", $$v)
              },
              expression: "printerJudgment.queue"
            }
          })
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "Χρώμα" } },
        [
          _c("el-input", {
            attrs: { placeholder: "Εισάγεται χρώμα" },
            model: {
              value: _vm.printerJudgment.color,
              callback: function($$v) {
                _vm.$set(_vm.printerJudgment, "color", $$v)
              },
              expression: "printerJudgment.color"
            }
          })
        ],
        1
      ),
      _c("hr"),
      _c("proposals"),
      _c("internalComments"),
      _c(
        "div",
        [
          _c(
            "el-form-item",
            { attrs: { label: "Επικαιροποίηση" } },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { disabled: "disabled" },
                  model: {
                    value: _vm.actApproval.approved,
                    callback: function($$v) {
                      _vm.$set(_vm.actApproval, "approved", $$v)
                    },
                    expression: "actApproval.approved"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: true } }, [
                    _vm._v("Ορθά στοιχεία")
                  ]),
                  _c("el-radio", { attrs: { label: false } }, [
                    _vm._v("Διόρθωση στοιχείων")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Παρατηρήσεις" } },
            [
              _c("el-input", {
                staticClass: "biggest",
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 4, maxRows: 10 },
                  placeholder: "Παρατηρήσεις για πράξη",
                  disabled: "disabled"
                },
                model: {
                  value: _vm.actApproval.comment,
                  callback: function($$v) {
                    _vm.$set(_vm.actApproval, "comment", $$v)
                  },
                  expression: "actApproval.comment"
                }
              })
            ],
            1
          ),
          _c("el-form-item", { attrs: { label: "Ημερομηνία Προσχεδίου" } }, [
            _c("span", { style: _vm.calcStyleDraft() }, [
              _vm._v(_vm._s(_vm.timeDraftUpload))
            ])
          ]),
          _c("el-form-item", { attrs: { label: "Ημερομηνία Έγκρισης" } }, [
            _c("span", { style: _vm.calcStyleApproval() }, [
              _vm._v(_vm._s(_vm.timeApprovedByUser))
            ])
          ]),
          this.isReappraisal
            ? _c(
                "el-form-item",
                { attrs: { label: "Έκδοση πράξης/επιστολής" } },
                [
                  this.attachments.length === 0
                    ? _c(
                        "el-select",
                        {
                          attrs: { placeholder: "Παρακαλώ Επιλέξτε" },
                          model: {
                            value: _vm.issuance,
                            callback: function($$v) {
                              _vm.issuance = $$v
                            },
                            expression: "issuance"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: "Έκδοση νέας πράξης αναγνώρισης",
                              value: "issueAct",
                              disabled: [
                                "ΑΠΟΡΡΙΨΗ ΩΣ ΕΚΠΡΟΘΕΣΜΗΣ",
                                "ΕΜΜΟΝΗ ΣΤΗΝ ΠΡΟΗΓΟΥΜΕΝΗ ΠΡΑΞΗ ΑΝΑΓΝΩΡΙΣΗΣ"
                              ].includes(this.presidentDecisionText)
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label:
                                "Έκδοση επιστολής απόρριψης εκπρόθεσμης αίτησης",
                              value: "issueOverdue",
                              disabled:
                                this.presidentDecisionText !==
                                "ΑΠΟΡΡΙΨΗ ΩΣ ΕΚΠΡΟΘΕΣΜΗΣ"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label:
                                "Έκδοση επιστολής εμμονής στην προηγ. πράξη",
                              value: "issueLetter",
                              disabled:
                                this.presidentDecisionText !==
                                "ΕΜΜΟΝΗ ΣΤΗΝ ΠΡΟΗΓΟΥΜΕΝΗ ΠΡΑΞΗ ΑΝΑΓΝΩΡΙΣΗΣ"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  this.attachments.length != 0
                    ? _c("el-alert", {
                        attrs: {
                          type: "info",
                          "show-icon": "",
                          title: "Υπάρχει ανεβασμένη πράξη/ επιστολή."
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.issuance === "issueLetter" ||
          _vm.issuance === "issueOverdue" ||
          (this.attachments.length !== 0 && _vm.printerJudgment.doatap_prot)
            ? _c(
                "el-form-item",
                { attrs: { label: "Α.Π. Επιστολής" } },
                [
                  _c("el-input", {
                    staticClass: "big",
                    attrs: {
                      type: "text",
                      placeholder: "Εισάγετε Αρ.Πρωτ. της αίτησης εμμονής "
                    },
                    model: {
                      value: _vm.printerJudgment.doatap_prot,
                      callback: function($$v) {
                        _vm.$set(_vm.printerJudgment, "doatap_prot", $$v)
                      },
                      expression: "printerJudgment.doatap_prot"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: _vm.calcLabel() } },
            [
              _c(
                "el-upload",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: this.uploading,
                      expression: "this.uploading"
                    }
                  ],
                  ref: "uploaPrint",
                  staticClass: "upload-demo",
                  attrs: {
                    accept: ".pdf",
                    "file-list": _vm.attachments,
                    "http-request": _vm.addAttachment,
                    "on-remove": _vm.handleRemove,
                    limit: 1,
                    "on-preview": _vm.viewPdf,
                    "before-remove": _vm.handleBeforeRemove,
                    action: "",
                    "auto-upload": true,
                    "show-file-list": true
                  }
                },
                [
                  _vm.attachments.length === 0
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                (this.isReappraisal && this.issuance) ||
                                (!this.isReappraisal && !this.issuance),
                              expression:
                                "(this.isReappraisal && this.issuance) || (!this.isReappraisal && !this.issuance)"
                            }
                          ],
                          attrs: {
                            slot: "trigger",
                            size: "small",
                            type: "primary"
                          },
                          slot: "trigger"
                        },
                        [_vm._v("Επιλογή αρχείου")]
                      )
                    : _vm._e(),
                  _vm.attachments.length === 0
                    ? _c(
                        "div",
                        {
                          staticClass: "el-upload__tip",
                          attrs: { slot: "tip" },
                          slot: "tip"
                        },
                        [_vm._v("Επιλέξτε ΕΝΑ αρχείο pdf μεγέθους μέχρι 12MB")]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("hr"),
      _c(
        "div",
        { staticStyle: { "text-align": "center" } },
        [
          _c(
            "el-button",
            {
              attrs: {
                size: "mini",
                type: "primary",
                round: "",
                disabled: false
              },
              on: { click: _vm.tempSave }
            },
            [_vm._v("Προσωρινή Αποθήκευση")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                size: "mini",
                type: "danger",
                round: "",
                disabled: false
              },
              on: { click: _vm.finalSave }
            },
            [_vm._v("Οριστική Υποβολή")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38b44071", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38b44071","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/roleSpecific/PrintDecisionJudgment.vue
// module id = null
// module chunks = 